import React from "react";

export default function DescriptionBanner({ title = 'Title', description = 'description' }) {
    return (
        <div className="w-full mx-auto  flex items-center">
            {/* Titolo */}
            <h1 className="text-2xl font-semibold text-gray-800 whitespace-nowrap mr-4">{title}</h1>

            {/* Descrizione */}
            <p className="text-gray-600 border-l-2 border-gray-400 pl-3">
                {description}
            </p>
        </div>
    );
}
